<template>
  <div class="UpdatePhoneViewContainer">
    <nut-row className="wbg brd16 pd16 vmg4 bothCenter mb16">
      <nut-col :span="12" class="leftCenter">
        <span>联系号码</span>
      </nut-col>
      <nut-col :span="12" class="rightCenter">
        <input class="infoInput smallFont" v-model="user.phone" placeholder="请输入"/>
      </nut-col>
    </nut-row>
    <nut-row className="wbg brd16 pd16 vmg4 bothCenter mb16">
      <nut-col :span="12" class="leftCenter">
        <span style="color: #2F438C" @click="send" v-if="timeout<=0">点击获取验证码</span>
        <span style="color: #5b98f8" v-else>{{ timeout }}s后重新获取</span>
      </nut-col>
      <nut-col :span="12" class="rightCenter">
        <input class="infoInput smallFont" v-model="captcha" placeholder="请输入"/>
      </nut-col>
    </nut-row>
    <nut-row className="wbg brd16 pd16 vmg4 bothCenter mb16">
      <nut-col :span="12" class="leftCenter">
        <span>新密码</span>
      </nut-col>
      <nut-col :span="12" class="rightCenter">
        <input class="infoInput smallFont" v-model="newPass" placeholder="请输入"/>
      </nut-col>
    </nut-row>
    <nut-row className="wbg brd16 pd16 vmg4 bothCenter mb16">
      <nut-col :span="12" class="leftCenter">
        <span>再次验证</span>
      </nut-col>
      <nut-col :span="12" class="rightCenter">
        <input class="infoInput smallFont" v-model="confirmNewPass" placeholder="请输入"/>
      </nut-col>
    </nut-row>
    <nut-row className="vmg4 leftCenter mb16">
      <span class="smallFont" style="color: #2F438C" @click="$router.back()">密码修改</span>
    </nut-row>
    <nut-row class="bothCenter vmg16">
      <nut-button class="btnA" @click="save">保存</nut-button>
    </nut-row>
  </div>
</template>

<script>
import api from "@/api";

export default {
  name: "ForgetPassView",
  data() {
    return {
      user: {},
      verifyToken: null,
      captcha: null,
      timeout: 0,
      timeoutTask: null,
      newPass: '',
      confirmNewPass: ''
    }
  },
  methods: {
    send() {
      api.captcha4resetpass()
          .then(ret => {
            this.verifyToken = ret.verifyToken;
            this.timeout = 120;
            this.timeoutTask = setInterval(() => {
              this.timeout -= 1;
              if (this.timeout < 1) {
                clearInterval(this.timeoutTask);
              }
            }, 1000);
          })
    },
    save() {
      api.resetPass({
        captcha: this.captcha,
        verifyToken: this.verifyToken,
        newPass: this.newPass,
        confirmNewPass: this.confirmNewPass,
      }).then(() => {
        this.$router.go(-2)
      })
    },
    init() {
      api.getUserInfo().then(ret => {
        this.user = ret;
      })
    }
  },
  mounted() {
    this.init()
  },
  unmounted() {
    clearInterval(this.timeoutTask);
  }
}
</script>

<style lang="scss" scoped>
.UpdatePhoneViewContainer {
  display: flex;
  flex-direction: column;
  background-color: #F4F6F9;
  padding: 16px;
  min-height: 100vh;

  .btnA {
    width: 160px;
    height: 44px;
    background: #2F438C;
    border-radius: 12px;
    color: white;
    border: none;
  }


  .btnB {
    width: 160px;
    height: 44px;
    background: rgba(0, 100, 255, 0.1);
    border-radius: 12px;
    color: #2F438C;
    border: none;
  }

  .infoInput {
    text-align: right;
    border: none;
    width: 45vw;
  }

  .infoInput:focus {
    outline: none;
  }

  .infoInput::placeholder {
    color: #999999;
  }
}
</style>